export default class VideoCategories
{
    constructor(htvApi) {
        this.htvApi = htvApi;
    }

    Get(id) {
        return this.htvApi.Call(this.htvApi.url + '/video-categories/' + id);
    }

    List() {
        return this
            .htvApi
            .Call(this.htvApi.url + '/video-categories');
    }

    Reorder(data) {
        return this.htvApi.Call(
            this.htvApi.url + '/video-categories/reorder',
            {
                method: 'POST',
                body: JSON.stringify(data),
            }
        );
    }

    Create(data) {
        let requestData = {
            titleTranslations: [],
            slug: data.slug,
            status: data.status,
        };

        for (const [locale, title] of Object.entries(data.titleTranslations)) {
            requestData.titleTranslations.push({locale: locale, value: title});
        }

        if (data.parentCategory !== null) {
            requestData.parent = '/video-categories/' + data.parentCategory;
        }

        return this.htvApi.Call(
            this.htvApi.url + '/video-categories',
            {
                method: 'POST',
                body: JSON.stringify(requestData),
            }
        );
    }

    Edit(id, data) {
        let requestData = {
            titleTranslations: [],
            slug: data.slug,
            status: data.status,
        };

        for (const [locale, title] of Object.entries(data.titleTranslations)) {
            requestData.titleTranslations.push({locale: locale, value: title});
        }

        return this.htvApi.Call(
            this.htvApi.url + '/video-categories/' + id,
            {
                method: 'PATCH',
                body: JSON.stringify(requestData),
                contentType: 'application/merge-patch+json',
            }
        );
    }

    Delete(id) {
        return this.htvApi.Call(this.htvApi.url + '/video-categories/' + id, {method: 'DELETE'});
    }
}
